import { requiredMessage, pleaseEnterTheMessage } from "../utils/common";
var emailRegex = function emailRegex(value) {
  return !/^(?:(?!.*(\.){2,}|^\.))[A-Z0-9!#$%&'*+\-/=?^_`{|}~.]+(\+)?[A-Z0-9]+(?:(?!\W+@|.@|:|\+))*(?:[A-Z0-9%+_-]+)*@(?:[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?\.)+[A-Z]{2,63}$/i.test(value);
};
var VARIANTS = {
  ARHI: "email address"
};
var VARIANT_REQUIRED_FUNCTION = {
  ARHI: requiredMessage,
  IAP: pleaseEnterTheMessage
};
var validEmail = function validEmail(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error; // eslint-disable-line init-declarations
  var field = fieldName || VARIANTS[funnel] || VARIANTS.ARHI;
  if (!value) {
    var requiredFunction = VARIANT_REQUIRED_FUNCTION[funnel] || VARIANT_REQUIRED_FUNCTION.ARHI;
    error = requiredFunction(field);
  } else if (emailRegex(value)) {
    error = "Please enter a valid ".concat(fieldName || VARIANTS[funnel] || VARIANTS.ARHI, ".");
  }
  return error;
};
export default validEmail;